module.exports = '3.14.1';



// WEBPACK FOOTER //
// ./src/version.js